import { isProduction } from './isProduction';

const URL_FLAG = 'skipStartedAtRelativeMinimum';

/**
 * E2E escape hatch: with the flag on the funnel URL, the start date drops the product's relative
 * minimum — a lead time an E2E run cannot wait out. The backend honors it on a test asset only.
 */
export function skipsStartedAtRelativeMinimum(): boolean {
  if (isProduction()) return false;

  return new URLSearchParams(window.location.search).has(URL_FLAG);
}
